import { render, staticRenderFns } from "./CytologyResultView.vue?vue&type=template&id=cdeffc98&scoped=true&"
import script from "./CytologyResultView.vue?vue&type=script&lang=js&"
export * from "./CytologyResultView.vue?vue&type=script&lang=js&"
import style0 from "./CytologyResultView.vue?vue&type=style&index=0&id=cdeffc98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdeffc98",
  null
  
)

export default component.exports